import { useQuery } from "@tanstack/react-query";

import { getFarmFeatureFlags, getFarmFeatureFlagsAdmin } from "services";

import { getEnvironment } from "utils";

import { GET_FARM_FEATURE_FLAGS } from "consts";

import { FarmFeatureFlagsResponse } from "models";

export const useGetFarmFeatureFlags = ({ farmId }: { farmId: string }) => {
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getFarmFeatureFlagsAdmin : getFarmFeatureFlags;

  return useQuery<FarmFeatureFlagsResponse[]>({
    queryKey: [GET_FARM_FEATURE_FLAGS, farmId, isAdmin],
    queryFn: () => queryFn({ farmId }),
    enabled: !!farmId,
    refetchInterval: 60000, // every 60 seconds
  });
};
